// User
export const SET_USER_AUTH        = 'Set User Authenticated'
export const SET_USER_ACTIVE_PUSH_TOKEN  	= 'Set User Active Push Token'
export const SET_USER_DESACTIVE_PUSH_TOKEN  = 'Set User Desactive Push Token'
export const SET_USER_PUSH_TOKEN  = 'Set User Push Token'
export const SET_USER_NAME        = 'Set User Full Name'
export const SET_USER_PICTURE_UID = 'Set User Picture UID'
export const SET_USER_PICTURE_B64 = 'Set User Picture Base64'
export const SET_USER_LOADING     = 'Set User Loading'
export const SET_USER_ERROR       = 'Set User Error'
export const SET_USER_SYNC        = 'Set User Readings Sync'
export const SET_USER_LOCALE      = 'Set User Locale'
export const CLEAR_USER           = 'Clear User'

export const SET_USER_PERMITTED_ACCOUNTS = 'Set User Permitted Accounts'
export const SET_USER_SELECTED_ACCOUNT   = 'Set User Selected Account'

// Plan
export const SET_PLAN         = 'Set Plan'
export const SET_PLAN_LOADING = 'Set Plan Loading'
export const SET_PLAN_ERROR   = 'Set Plan Error'
export const CLEAR_PLAN       = 'Clear Plan'

// Watches
export const SET_WATCHES         = 'Set Watches'
export const SET_WATCHES_LOADING = 'Set Watches Loading'
export const SET_WATCHES_ERROR   = 'Set Watches Error'
export const CLEAR_WATCHES       = 'Clear Watches'
export const SET_PROFILE         = 'Set Watch Profile'
export const SET_PROFILE_LOADING = 'Set Watch Profile Loading'
export const SET_PROFILE_ERROR   = 'Set Watch Profile Error'
export const SET_PICTURE         = 'Set Watch Picture'
export const SET_PICTURE_LOADING = 'Set Watch Picture Loading'
export const SET_PICTURE_ERROR   = 'Set Watch Picture Error'

// Alerts
export const SET_ALERTS         = 'Set Alerts'
export const SET_ALERTS_LOADING = 'Set Alerts Loading'
export const SET_ALERTS_ERROR   = 'Set Alerts Error'
export const CLEAR_ALERTS       = 'Clear Alerts'

// Forms
export const ADD_FORM    = 'Add Form'
export const DEL_FORM    = 'Del Form'
export const CLEAR_FORMS = 'Clear Forms'

// Admin
export const ADMIN_ALLOC_WATCH   = 'Admin Allocate Watch'
export const ADMIN_ADD_WATCH     = 'Admin Add Watch'
export const ADMIN_DEL_WATCH     = 'Admin Delete Watch'
export const ADMIN_WATCH_LOADING = 'Admin Watch Loading'
export const ADMIN_WATCH_ERROR   = 'Admin Watch Error'

// Accounts
export const SET_ACCOUNTS         = 'Set Accounts'
export const SET_ACCOUNTS_LOADING = 'Set Accounts Loading'
export const SET_ACCOUNTS_ERROR   = 'Set Accounts Error'
export const CLEAR_ACCOUNTS       = 'Clear Accounts'

export const SET_ACCOUNT_PICTURE         = 'Set Account Picture'
export const SET_ACCOUNT_PICTURE_LOADING = 'Set Account Picture Loading'
export const SET_ACCOUNT_PICTURE_ERROR   = 'Set Account Picture Error'

export const SET_ACCOUNT_ALERTS         = 'Set Account Alerts'
export const SET_ACCOUNT_ALERTS_LOADING = 'Set Account Alerts Loading'
export const SET_ACCOUNT_ALERTS_ERROR   = 'Set Account Alerts Error'

export const SET_ACCOUNT_WATCHES         = 'Set Account Watches'
export const SET_ACCOUNT_WATCHES_LOADING = 'Set Account Watches Loading'
export const SET_ACCOUNT_WATCHES_ERROR   = 'Set Account Watches Error'

export const SET_ACCOUNT_WATCH_PROFILE         = 'Set Account Watch Profile'
export const SET_ACCOUNT_WATCH_PROFILE_LOADING = 'Set Account Watch Profile Loading'
export const SET_ACCOUNT_WATCH_PROFILE_ERROR   = 'Set Account Watch Profile Error'

export const SET_ACCOUNT_WATCH_PICTURE         = 'Set Account Watch Picture'
export const SET_ACCOUNT_WATCH_PICTURE_LOADING = 'Set Account Watch Picture Loading'
export const SET_ACCOUNT_WATCH_PICTURE_ERROR   = 'Set Account Watch Picture Error'

// Permissions
export const SET_PERMISSIONS         = 'Set Permissions'
export const SET_PERMISSIONS_LOADING = 'Set Permissions Loading'
export const SET_PERMISSIONS_ERROR   = 'Set Permissions Error'
export const CLEAR_PERMISSIONS       = 'Clear Permissions'



// WEBPACK FOOTER //
// ./src/store/modules/mutations/index.js